import { Modal, inputCls, btnPrimary } from "../bits";

export function ChallengeFormModal({ open, onClose, form, setForm, busy, onSave }) {
  return (
    <Modal open={open} onClose={onClose} title="تحدٍّ أسبوعي جديد" testid="challenge-form-modal">
      <div className="space-y-3">
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">عنوان التحدي *</label>
          <input data-testid="challenge-title-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">الوصف</label>
          <textarea data-testid="challenge-desc-input" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className={inputCls} rows={2} />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs font-bold text-mutext block mb-1.5">بداية الأسبوع</label>
            <input data-testid="challenge-start-input" type="date" value={form.week_start} onChange={(e) => setForm({ ...form, week_start: e.target.value })} className={inputCls} dir="ltr" />
          </div>
          <div>
            <label className="text-xs font-bold text-mutext block mb-1.5">نهاية الأسبوع</label>
            <input data-testid="challenge-end-input" type="date" value={form.week_end} onChange={(e) => setForm({ ...form, week_end: e.target.value })} className={inputCls} dir="ltr" />
          </div>
        </div>
        <button data-testid="challenge-save-btn" onClick={onSave} disabled={busy} className={`${btnPrimary} w-full justify-center`}>
          {busy ? "جارٍ النشر …" : "نشر التحدي وإشعار المنسقين"}
        </button>
      </div>
    </Modal>
  );
}

export function WinnerModal({ challenge, schools, winnerId, setWinnerId, busy, onSave, onClose }) {
  return (
    <Modal open={!!challenge} onClose={onClose} title={`تتويج الفائز — ${challenge?.title || ""}`} testid="winner-modal">
      <div className="space-y-3">
        <label className="text-xs font-bold text-mutext block mb-1.5">المدرسة الفائزة</label>
        <select data-testid="winner-school-select" value={winnerId} onChange={(e) => setWinnerId(e.target.value)} className={inputCls}>
          <option value="">— اختر المدرسة —</option>
          {schools.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
        <button data-testid="winner-save-btn" onClick={onSave} disabled={busy} className={`${btnPrimary} w-full justify-center`}>
          {busy ? "جارٍ الحفظ …" : "تتويج وإغلاق التحدي"}
        </button>
      </div>
    </Modal>
  );
}
